import type { LucideIcon } from 'lucide-react'
import { sdk } from '@/lib/sdk'
import type { MediaShowModule } from '@/lib/sdk-official/resources/media-shows'
import { lazyPage } from '@/lib/lazyPage'
import type { ModuleDefinition, SpacePageProps } from '../../types'
import { ShowsSpaceFields } from './ShowsSpaceFields'
import { showsModeApiErrors } from './showsMode'

const MediaShowsPage = lazyPage(() => import('./MediaShowsPage'), 'MediaShowsPage')
const EpisodePage = lazyPage(() => import('./EpisodePage'), 'EpisodePage')

/**
 * F-178: Podcast and Vídeos are two space modules over one engine (shows and
 * episodes). "One show" or "several" is the space's `moduleConfig.mode`.
 */
export const mediaShowModule = (key: MediaShowModule, icon: LucideIcon, iconName: string): ModuleDefinition => ({
  key,
  icon,
  iconName,
  namespaces: ['media'],
  ready: true,
  ListPage: (props: SpacePageProps) => <MediaShowsPage {...props} module={key} />,
  /* `/{section}/{space}/{episodeId}` is an episode; `new?show=` is the editor of a new one. */
  renderDetail: ({ spaceData, params }) => (params.itemId ? <EpisodePage key={params.itemId} module={key} spaceData={spaceData} itemId={params.itemId} /> : null),
  setup: {
    wizardStep: 'details',
    defaultWhoCanPost: 'admins',
    defaultConfig: () => ({ mode: 'multi' }),
    validate: () => null,
    errorsFromApi: (err) => showsModeApiErrors(err),
    Fields: ShowsSpaceFields,
    persist: {
      type: 'moduleConfig',
      toModuleConfig: (config, stored) => ({ ...(stored || {}), mode: config?.mode === 'single' ? 'single' : 'multi' }),
      fromSpace: (space) => ({ mode: (space.moduleConfig as Record<string, unknown> | null | undefined)?.mode === 'single' ? 'single' : 'multi' })
    }
  },
  /* Who publishes is owner, admin and the show's presenters, not "who can post". */
  posting: false,
  singleItem: { isEmpty: async (spaceId) => (await sdk.mediaShows.list(spaceId)).items.length === 0 }
})
